module.exports = __webpack_public_path__ + "static/youth-ministry-1c457af14938449391d42941803a6f72.jpg";